module.exports = __webpack_public_path__ + "static/media/stratusControl.904b8029.png";